import React from "react";
import { Box } from "@mui/material";
import ChatAttachments from "../ChatAttachments";
import { ChatMessageWithFiles } from "../types";
import { ChatMessageWithParts } from "src/views/assistant/types";

type ChatMessageAttachmentsProps = {
  chatMessage: ChatMessageWithParts;
};

/**
 * Component to display file attachments in a chat message
 * This component checks if the message has file attachments and displays them
 */
const ChatMessageAttachments: React.FC<ChatMessageAttachmentsProps> = ({
  chatMessage,
}) => {
  // Check if the message has file attachments
  const messageWithFiles = chatMessage as ChatMessageWithFiles;
  const hasFiles = messageWithFiles.files && messageWithFiles.files.length > 0;

  if (!hasFiles) {
    return null;
  }

  return (
    <Box sx={{ mt: 1 }}>
      <ChatAttachments files={messageWithFiles.files!} />
    </Box>
  );
};

export default ChatMessageAttachments;
